export default {
  QInput: {
    charNumber: '字符数'
  },
  QSelect: {
    loading: '加载中...',
    more: '未显示所有结果，请优化您的搜索',
    noMatch: '无匹配数据',
    noData: '无数据',
    selectAll: '全选'
  },
  QTextarea: {
    charNumber: '字符数'
  },
  QDatePicker: {
    placeholder: '选择日期',
    startPlaceholder: '开始',
    endPlaceholder: '结束',
    prevYear: '前一年',
    nextYear: '后一年',
    prevMonth: '前一月',
    nextMonth: '后一月',
    timeFrom: '从',
    timeTo: '至'
  },
  QCascader: {
    placeholder: '选择',
    noDataText: '无数据'
  },
  QColorPicker: {
    clear: '清空',
    confirm: '确定'
  },
  QTable: {
    noDataText: '无数据'
  },
  QUpload: {
    uploadFile: '上传文件',
    replaceFile: '替换文件',
    loading: '加载中',
    uploadedFiles: '已上传文件'
  }
};
